import { useEffect, useRef } from "react";
import type { ActionRecord } from "../server/types";

type Props = {
  actions: ActionRecord[];
};

function formatAction(action: ActionRecord): string {
  switch (action.toolName) {
    case "advance_frames": {
      const frames = action.input.frames as number;
      const buttons = (action.input.buttons as string[]) || [];
      return `► advance ${frames}f [${buttons.join("+")}]`;
    }
    case "save_state":
      return `► save "${action.input.slot_name}"`;
    case "load_state":
      return `↩ load "${action.input.slot_name}"`;
    case "get_screenshot":
      return `📷 screenshot`;
    default:
      return `► ${action.toolName}`;
  }
}

function getActionColor(action: ActionRecord): string {
  if (action.rewound) return "text-nes-gray line-through opacity-40";
  switch (action.toolName) {
    case "advance_frames":
      return "text-nes-blue";
    case "save_state":
      return "text-nes-green";
    case "load_state":
      return "text-nes-gold";
    default:
      return "text-nes-white";
  }
}

export function ActionLog({ actions }: Props) {
  const scrollRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
  }, [actions.length]);

  return (
    <div className="nes-panel flex flex-col" style={{ minHeight: "200px", maxHeight: "300px" }}>
      <div className="nes-panel-header">ACTION LOG</div>
      <div
        ref={scrollRef}
        className="flex-1 overflow-y-auto p-3 font-pixel text-xs space-y-0.5"
        style={{ maxHeight: "250px" }}
      >
        {actions.length === 0 ? (
          <span className="text-nes-gray">No actions yet</span>
        ) : (
          actions.map((action) => (
            <div key={action.id} className={getActionColor(action)}>
              {formatAction(action)}
            </div>
          ))
        )}
      </div>
    </div>
  );
}
